import React from 'react';

const GreenUpArrowIcon = () => {
    return (
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.46387 10.5586C6.12866 7.75522 7.6227 6.18349 10.2875 3.38012" stroke="#70CFD6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.76367 3.22949L10.8334 3.23654L10.8334 7.80969" stroke="#70CFD6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default GreenUpArrowIcon;